export const FOOTER_DETAILS = {
  ammendedBy: 'Chapter 293',
  ammendedSession: '2018 General Session',
};

export const HEADER_DETAILS = {
  chapterCode: '2',
  chapter: 'Property Tax Act',
  effective: '5/8/2018',
  effectiveUntil: '5/1/2024',
  part: 'Collection of Taxes',
  partCode: '13',
  section:
    'Property tax due date -- Date tax is delinquent -- Penalty -- Interest -- Payments -- Refund of prepayment.',
  sectionCode: '1331',
  superseded: '5/1/2024',
  titleCode: '59',
  title: 'Revenue and Taxation',
};
